import { type FC } from 'react';
import { SidebarItem, SidebarSection, Text, VStack } from '@direct-frontend/components';
import { matchPath, useLocation } from '@direct-frontend/modules-router';
import { getSafeUserRequestContext } from '#shared/lib/context';
import { getMenuConfiguration, OTHER_MENU_ITEM } from './lib/constants';
import styles from './SettingsNavMenu.module.css';

type SettingsNavMenuProps = {};

export const SettingsNavMenu: FC<SettingsNavMenuProps> = () => {
    const location = useLocation();
    const locationPathname = location.pathname;

    const { isInternalYandexUser } = getSafeUserRequestContext();
    const { settingsMenuItems } = getMenuConfiguration();

    return (
        <VStack className={styles.root} data-testid="SettingsNavMenu">
            <Text size="s" bold className={styles.title}>
                Настройки
            </Text>
            <SidebarSection>
                {settingsMenuItems.map(({ routes, ...menuItem }) => {
                    const isActive = routes.some((route) => matchPath(route, locationPathname));

                    if (menuItem.itemId === OTHER_MENU_ITEM.itemId && !isInternalYandexUser) {
                        return null;
                    }

                    return <SidebarItem key={menuItem.itemId} {...menuItem} isActive={isActive} isTitleBold={false} />;
                })}
            </SidebarSection>
        </VStack>
    );
};
